import { themeColors } from './colors';
import { rgba } from 'polished';
var remScale = 16;
var gridSize = 0.5;
/* rem */

export var theme = {
  gridSize: gridSize,
  remScale: remScale,
  colors: themeColors,
  borderSize: ['1px', '2px'],
  borderRadius: ['0.125rem', '0.25rem'],
  baseLineHeight: '1.1875rem',
  // 19px
  fonts: {
    normal: fontStack(['Clear Sans', 'arial', 'sans-serif'])
  },
  fontSizes: ['0.625rem', // 0: 10px
  '0.75rem', // 1: 12px
  '0.875rem', // 2: 14px
  '1rem', // 3: 16px
  '1.125rem', // 4: 18px
  '1.3125rem', // 5: 21px
  '1.65rem', // 6: 26.4px
  '2rem' // 7: 32px
  ],
  space: [
  /** space-00 */
  '0',
  /** space-01 */
  "".concat(gridSize * 0.5, "rem"), // 4px

  /** space-02 */
  "".concat(gridSize, "rem"), // 8px // fm. space-1

  /** space-03 */
  "".concat(gridSize * 1.5, "rem"), // 12px

  /** space-04 */
  "".concat(gridSize * 2, "rem"), // 16px // fm. space-2

  /** space-05 */
  "".concat(gridSize * 3, "rem"), // 24px // fm. space-3

  /** space-06 */
  "".concat(gridSize * 4, "rem"), // 32px // fm. space-4

  /** space-07 */
  "".concat(gridSize * 5, "rem"), // 40px

  /** space-08 */
  "".concat(gridSize * 6, "rem"), // 48px // fm. space-5

  /** space-09 */
  "".concat(gridSize * 8, "rem") // 64px // fm. space-6
  ],
  controlSize: {
    xs: "".concat(gridSize * 9, "rem"),
    // 72px
    sm: "".concat(gridSize * 19, "rem"),
    // 152px
    md: "".concat(gridSize * 31, "rem"),
    // 248px
    lg: "".concat(gridSize * 44.5, "rem"),
    // 356px
    xl: "".concat(gridSize * 56.5, "rem") // 452px

  },
  shadows: ["0 0.0625rem 0.125rem ".concat(rgba(themeColors['neutral-500'], 0.25)), "0 0.125rem 0.375rem ".concat(rgba(themeColors['neutral-500'], 0.35))],
  transitions: {
    fast: '0.2s ease-in-out',
    normal: '0.35s ease-in-out',
    slow: '0.75s ease-in-out'
  },
  breakpoints: ['85.1rem'
  /* > 1360px */
  , '90.1rem'
  /* > 1440px */
  , '105.1rem'
  /* > 1680px */
  ]
};

function fontStack(fonts) {
  return fonts.map(function (font) {
    return font.includes(' ') ? "\"".concat(font, "\"") : font;
  }).join(', ');
}

export var transition = function transition(properties, speed) {
  return properties.map(function (p) {
    return "".concat(p, " ").concat(theme.transitions[speed || 'normal']);
  }).join(', ');
};